<template>
  <NBar title="首页"/>
</template>

<script>
export default {
  name: 'DeviceGoods',
  data () {
    return {}
  },
  mounted () {
    this.$api.post({
      url: '/device/api/device/device-account/find',
      that: this
    }).then(res => {
    })
  },
  methods: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/device/DeviceGoods.vue